import React from "react";
// import ReactDOM from "react-dom";
import "./index.css";
import App from "./App.js";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

import ReactDOM from "react-dom/client";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter basename="/v1">
    
      <App />
  </BrowserRouter>
);

// ReactDOM.render(
//   <BrowserRouter>
//     <UserProvider>
//       <App />
//     </UserProvider>
//   </BrowserRouter>,
//   document.getElementById("root")
// );
